module.exports = __webpack_public_path__ + "static/media/delivery.0138d609.svg";